export default __webpack_public_path__ + "4c776148d277d88aca2f3887cf4e618a.svg";